import { computed, onMounted, ref } from 'vue';
import { showLoginHandler } from '@/utils/login-by-env';
import { showMessage } from '@vas2t-lowcode/utils';
import { usePTeamStore, usePUserStore } from '@/store';
import { ITeamAppListBy_tplParams, RespTplApp } from '@vas2t-lowcode/api';
import { reqTeamAppListByTplAsync, resetTeamAppListByTplAsync } from '../workspace-app/workspace-app-interface';
import { dwOnAppTemplateClick } from './app-list.dw';
import { getSelectedTemplate } from './app-list.tool';

/**
 * 应用创建
 *
 * @param appData
 * @returns
 */
export const useWTemplateAppCreate = (appData: RespTplApp) => {
  /** 是否显示工作区下的应用列表 */
  const isShowWorkspaceAppCreate = ref(false);
  const userStore = usePUserStore();
  const teamStore = usePTeamStore();
  /** 是否为工作区创建者 */
  const hasCreateAppPermission = computed(() => {
    return teamStore.isWorkbenchOwner || teamStore.isWorkbenchManager;
  });
  /** 工作区id */
  const workspaceId = computed(() => {
    return teamStore.workbenchId;
  });
  // #region 工作区应用列表
  /** 是否显示应用列表，基于工作区和模板 */
  const isShowAppList = ref(false);
  /** 请求用户列表 */
  const isGetAppListLoading = ref(false);
  /** 是否已创建过应用，基于当前工作区和模板 */
  const isAppCreatedBefore = ref(false);
  const getAppList = () => {
    if (isGetAppListLoading.value) {
      return;
    }
    const teamId = Number(workspaceId.value) || 0;
    if (!teamId) {
      return;
    }
    isGetAppListLoading.value = true;
    const params = {
      platform_id: appData.platform_id,
      tpl_id: appData.tpl_id,
      team_id: teamId,
    } as ITeamAppListBy_tplParams;
    return reqTeamAppListByTplAsync(params)
      .then(({ data }) => {
        isAppCreatedBefore.value = !!data.length;
      })
      .finally(() => {
        isGetAppListLoading.value = false;
        resetTeamAppListByTplAsync();
      });
  };
  /** 创建app */
  const createTemplateApp = async () => {
    const selectedTemplateType = getSelectedTemplate();
    dwOnAppTemplateClick(selectedTemplateType?.name, appData.name, appData.tpl_id);

    if (!userStore.isLogin) {
      showLoginHandler();
      return;
    }

    // 如果用户未创建过工作区，则直接创建应用
    if (!teamStore.isShowWorkbench) {
      isShowWorkspaceAppCreate.value = true;
      return;
    }

    // 根据当前工作区角色判断创建权限
    if (!hasCreateAppPermission.value) {
      showMessage({ msgContent: '暂无权限，请联系工作区拥有者或切换至自己的工作区', msgType: 'error' });
      return;
    }

    // 判断当前基于该模板创建的应用数
    await getAppList();

    // 判断当前工作去下相同的应用是否存在多个
    if (isAppCreatedBefore.value) {
      // 显示应用列表
      isShowAppList.value = true;
      return;
    }

    // 上面情况都不符合，则直接创建应用
    isShowWorkspaceAppCreate.value = true;
  };

  /** 工作区创建弹窗关闭事件 */
  const onWorkspaceAppCreateDialogClosed = (data: { isCloseAll: boolean }) => {
    isShowWorkspaceAppCreate.value = false;

    // 判断是否关闭当前弹窗
    // const { isCloseAll } = data;
    // if (isCloseAll) {
    //   dialogVisible.value = false;
    // }
  };

  /** 应用列表弹窗关闭事件 */
  const onWorkspaceAppDialogClosed = (data: { isShowCreateApp?: boolean }) => {
    isShowAppList.value = false;

    if (data.isShowCreateApp !== undefined) {
      isShowWorkspaceAppCreate.value = data.isShowCreateApp;
    }
  };

  return {
    isShowWorkspaceAppCreate,
    createTemplateApp,
    workspaceId,
    onWorkspaceAppCreateDialogClosed,
    onWorkspaceAppDialogClosed,
    isAppCreatedBefore,
    isShowAppList,
  };
};
// #endregion
